import validation from '../../../../../modules/Gull/Framework/validation.js';

const newOpvolgend = {

	init() {

		// Toon en verberg velden wanneer soort melding wordt gewijzigd
		$('#Type').change(function(e) {
			e.preventDefault();
			var v = $(this).val();
			var a = $('.form-section-algemeen');
			var d = $('.form-section-details');
			var t = $('.form-section-42eweek');
			var w = $('.form-section-wia');
			var z = $('.form-section-ziektewet');
			$('span.opvolg-soort-label').text(v);
			$.each([a, d, t, w, z], function(i, e) {
				e.addClass('d-none');
				validation.removeRequired(e.find('input[type=text],select'));
			});
			if (v == 'Ziektewet') {
				z.removeClass('d-none');
				validation.addRequired(z.find('input[type=text],select'));
			} else if (v == 'WIA') {
				w.removeClass('d-none');
				validation.addRequired(w.find('input[type=text],select'));
			}
		});

		// Trigger change van Type veld wanneer pagina geladen wordt
		$('#Type').trigger('change');

		// Het beëindigen van een melding bij een werknemer.
		$('body').on('change', '#Begindatum', function() {
			$('.alert-confirmation').closest('.row').addClass('d-none');
			if (($('#Begindatum').val() != '')) {
				var eindDatumArray = $('#Begindatum').val().split('-');
				var datum = new Date(eindDatumArray[2] + '-' + eindDatumArray[1] + '-' + eindDatumArray[0]);
				var datumTxt = datum.getDate() + '-' + (datum.getUTCMonth() + 1) + '-' + datum.getFullYear();
				$('.alert-confirmation').find('span.uitdienst-begindatum-0').html(datumTxt);
				datum.setDate(datum.getDate() - 1);
				datumTxt = datum.getDate() + '-' + (datum.getUTCMonth() + 1) + '-' + datum.getFullYear();
				$('.alert-confirmation').find('span.uitdienst-begindatum-1').html(datumTxt);
				$('.alert-confirmation').closest('.row').removeClass('d-none');

			}
		});
		$('#Begindatum').trigger('change');

	}

};

export default newOpvolgend;
